module.exports = __webpack_public_path__ + "static/media/tutorial-current-threat.0ddd603c.png";